export default __webpack_public_path__ + "static/media/Boys_Jump_Spin.d2a77716.svg";